import { render } from "./benefit.vue?vue&type=template&id=361f86ee&scoped=true"
import script from "./benefit.vue?vue&type=script&lang=js"
export * from "./benefit.vue?vue&type=script&lang=js"

import "./benefit.vue?vue&type=style&index=0&id=361f86ee&scoped=true&lang=scss"

import exportComponent from "D:\\project\\pc\\website\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361f86ee"]])

export default __exports__